import axios from 'axios';
import TomSelect from 'tom-select';

declare let booking_object: any;

export default class timeSlot{

    /**
     * Get time slot
     * @returns 
     */
    get(
        book_calendar: any,
        el_rooms: string,
        el_games: string,
        el_time_slot: string
    ){

        const _that = this;

        // Element room
        const elRoom = document.querySelector(el_rooms) as HTMLSelectElement | null;
        
        // Element game
        const elGame = document.querySelector(el_games) as HTMLSelectElement;

        // Element time slot
        const elTimeSlot = document.querySelector(el_time_slot) as HTMLSelectElement | null;
        
        const settings: any = {
            plugins: ['dropdown_input'],
            valueField: 'slot_time',
            labelField: 'slot_start_time',
            searchField: 'slot_start_time',
            preload: true,
            load: function (query, callback) {

                const q = {
                    'name' : query
                }
                
                // Post data
                const post_data = {
                    'room_id': (elRoom !== null) ? elRoom.value : '',
                    'game_id': (elGame !== null) ? elGame.value : '',
                    'date': book_calendar.getDate('y/mm/dd'),
                };
            
                // Query string
                const queryString = new URLSearchParams(post_data).toString();
    
                // Call ajax
                axios.post(booking_object.rest_urls.get_room, queryString)
                .then(function (response: any) {
    
                    callback(response.data);

                })
                .catch(function (error: any){
    
                    console.log(error);
    
                });
            },
            render: {
                option: function (item, escape) {
                    return '<span class="block w-full fluid-text-xs">'+ escape(item.slot_start_time) + ' - ' + escape(item.slot_end_time) +'</span>';
                },
                item: function (item, escape) {

                    if (item.slot_start_time === null || item.slot_end_time === null) {
                        
                        return '<span>' + escape(item.no_data) + '</span>';

                    }else{
                        
                        return '<span>' + escape(item.slot_start_time) + ' - ' + escape(item.slot_end_time) + '</span>';

                    }

                },
            }
        };

        const control: TomSelect = new TomSelect(el_time_slot, settings);

        if(elRoom !== null){
            
            const val_room = elRoom.value;
            
            if(val_room.length === 0){
            
                if(elTimeSlot !== null) {
                    
                    control.disable();
                
                }
                
            }

        }

        this.refreshTimeSlot(
            el_time_slot,
            book_calendar,
            el_rooms,
            el_games,
        );

        return control;
    
    }

    refreshTimeSlot(
        elTimeSlot: string,
        book_calendar: any,
        el_rooms: string,
        el_games: string,
    ){
        
        const _that = this;

        // Element room
        const elRoom = document.querySelector(el_rooms) as HTMLSelectElement | null;
        
        // Element game
        const elGame = document.querySelector(el_games) as HTMLSelectElement;

        elRoom?.addEventListener('change', function(e){
            
            e.preventDefault();

            _that.changeRoomTimeSlotSelect(
                book_calendar,
                elRoom.value,
                (elGame !== null) ? elGame?.value : '',
                elTimeSlot
            );

        });

        elGame?.addEventListener('change', function(e){
            
            e.preventDefault();

            _that.changeRoomTimeSlotSelect(
                book_calendar,
                (elRoom !== null) ? elRoom?.value : '',
                (elGame !== null) ? elGame?.value : '',
                elTimeSlot
            );

        });

        if (typeof book_calendar.pickerElement !== 'undefined') {
            
            book_calendar.pickerElement.addEventListener('click', (ev) => {

                _that.changeRoomTimeSlotSelect(
                    book_calendar,
                    (elRoom !== null) ? elRoom?.value : '',
                    (elGame !== null) ? elGame?.value : '',
                    elTimeSlot
                );

            });

        }
        
    }

    /**
     * Change time slot
     * @param elRoom 
     * @param control 
     */
    changeRoomTimeSlotSelect(
        book_calendar: any,
        val_room: string,
        val_game: string,
        el_time_slot: string
    ){

        const _that = this;

        // Element time slot
        const elTimeSlot: any = document.querySelector(el_time_slot);
        const control = elTimeSlot.tomselect;

        control.clear();
        control.clearOptions();

        const val_date = book_calendar.getDate('y/mm/dd');

        if(typeof val_date !== 'undefined' && val_room.length !== 0 && val_game.length !== 0){

            // Post data
            const post_data = {
                'room_id': val_room,
                'game_id': val_game,
                'date': val_date,
            };
        
            // Query string
            const queryString = new URLSearchParams(post_data).toString();
    
            // Call ajax
            axios.post(booking_object.rest_urls.get_room, queryString)
            .then(function (response: any) {

                const data = response.data.data;

                const isObjectEmpty = (objectName) => {
                    return Object.keys(objectName).length === 0
                }

                if(typeof data === 'object' && data !== null){
                            
                    // Checking if the object is not empty
                    if(!isObjectEmpty(data)){
                        
                        control.enable();
                        control.addOptions(response.data, false);
                        control.setValue([data[0].slot_time]);

                    }else{
                        
                        control.addOption({
                            slot_time: '',
                            slot_start_time: null,
                            slot_end_time: null,
                            no_data: 'Nessuno slot disponibile'
                        });
                        control.setValue('');
                        control.disable();

                    }

                }else if(typeof data === 'string'){
                    
                    // If the data is a string, do something (modify as needed)
                    control.addOption({
                        slot_time: '',
                        slot_start_time: null,
                        slot_end_time: null,
                        no_data: 'Sala chiusa'
                    });
                    control.setValue('');
                    control.disable();

                }else{
                    
                    // Case in which the data is neither an object nor a string
                    control.setValue('');
                    control.disable();

                }

            })
            .catch(function (error: any){
    
                console.log(error);
    
            });

        }else{

            return;

        }
        
    }

}